import axios from 'axios';

const { config } = window;

export default class Api {
  static getConf(multi = false) {
    const accessToken = localStorage.getItem('access_token');
    return {
      baseURL: config.apiUrl,
      validateStatus: false,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': multi ? 'multipart/form-data' : 'application/json',
      },
    };
  }

  static async post(url, data = {}, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const response = await axios.post(url, data, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`Art API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      return e;
    }
  }

  static async delete(url, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const response = await axios.delete(url, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`Art API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      return e;
    }
  }

  static async patch(url, data = {}, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const dataFix = {
        ...data,
      };
      // eslint-disable-next-line no-underscore-dangle
      dataFix._method = 'PATCH';
      const response = await axios.post(url, dataFix, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`Art API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      return e;
    }
  }

  static async get(url, throwErrors = false) {
    const axiosConf = this.getConf();
    try {
      const response = await axios.get(url, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`Art API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      return e;
    }
  }

  static async uploadOneFile(url, file, additionalPostData = {}, throwErrors = false) {
    const axiosConf = this.getConf(true);
    const data = new FormData();
    data.append('file', file);

    if (additionalPostData) {
      const additionalDataKeys = Object.keys(additionalPostData);
      for (let i = 0; i < additionalDataKeys.length; i += 1) {
        const objectKey = additionalDataKeys[i];
        data.append(objectKey, additionalPostData[objectKey]);
      }
    }

    try {
      const response = await axios.post(url, data, axiosConf);
      if (throwErrors && (response.status <= 100 || response.status >= 400)) {
        throw new Error(`Art API Returned error status ${response.status}`);
      }
      return response;
    } catch (e) {
      return e;
    }
  }
}
